<template>
  <div class="mainwrap">
    <div class="tune-widget-mainbar">
      <div class="tune-widget-mainbar-l">
          <logo-link :logo="img1" :link="siteLinkout"/>
      </div>
      <div class="tune-widget-mainbar-m">
        <div class="tune-widget-maintitle">{{ $t("maintitle") }}</div>
      </div>
      <div class="tune-widget-mainbar-r">
        <div class="header-icon-wrapper" v-if=" orderSystem == '1'">
          <span class="count-icon" @click="gotoShop()">
            <img :src="cartWhite" class="shop-icon-big" alt="shop" />
            <span class="count-big"> {{ itemsInCart }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="tune-widget">
      <div class="center-widget">
        <!-- <span class="tune-widget-title">{{ $t("tool_label") }}</span> -->
        <div class="field-25">
          <select
            id="language"
            @change="changeItem('language', $event)"
            v-model="$i18n.locale"
            class="tool-main-select"
          >
            <option value="en">{{ $t("lang_en") }}</option>
            <option value="nl">{{ $t("lang_nl") }}</option>
          </select>
        </div>

        <!-- Select brand -->
        <div v-if="curMakes.length" class="field-25">
          <select
            id="make"
            @change="changeItem('make', $event)"
            v-model="selectedMake"
            class="tool-main-select"
          >
            <option value="">{{ $t("select_brand") }}</option>
            <option
              v-for="make in curMakes"
              v-bind:key="make.MakeID"
              v-bind:value="make.MakeID"
            >
              {{ make.Make }}
            </option>
          </select>
        </div>
        <div v-else>
          <!-- <p>Loading manufacturers</p> -->
          <button @click="getMakes()">{{ $t("reload") }}</button>
        </div>

        <!-- Select Model -->
        <div v-if="curModels.length > 0" class="field-25">
          <select
            id="model"
            @change="changeItem('model', $event)"
            v-model="selectedModel"
            class="tool-main-select"
          >
            <option value="">{{ $t("model") }}</option>
            <option
              v-for="model in curModels"
              v-bind:key="model.ModelID"
              v-bind:value="model.ModelID"
            >
              {{ model.Description }} - {{ model.ModelType }}
            </option>
          </select>
        </div>

        <!-- Select variants -->
        <div v-if="curVariants.length > 0" class="field-25">
          <select
            id="variant"
            @change="changeItem('options', $event)"
            v-model="selectedVariant"
            class="tool-main-select"
          >
            <option value="">{{ $t("variant") }}</option>
            <option
              v-for="variant in curVariants"
              v-bind:key="variant.VariantID"
              v-bind:value="variant.VehicleID"
            >
              {{ variant.ModelVariant }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="center-widget">
        <!-- <transition name="fade"> -->
          <div class="tuning-results-action-popup" v-if="actionDialog">
            <!-- <div class="tuning-results-row"><button @click=hideProductAction()>{{ $t("back") }}</button></div> -->
            <div v-if="curActionMode == 'order'">
              <!-- <cart-view /> -->
            </div>
            <div v-if="curActionMode == 'appointment'">
              <appointment-view :closePopup="hideProductAction" />
            </div>
            <div v-if="curActionMode == 'info'">
              <inforequest-view :closePopup="hideProductAction" />
            </div>
            <div v-if="curActionMode == 'download'">
              <!-- <div class="tuning-results-row"><button @click="downloadPDF()">Download PDF</button></div> -->
            </div>
          </div>
        <!-- </transition> -->
        <div class="tune-results" v-if="hasResults">
          <!-- <div class=""> api_url: {{ this.$store.state.cdn_url }}</div> -->
          <div class="tuning-results-mainpane">

              <div class="tune-top-header">
                <div class="tune-top-header-logo">
                  <img :src="curTuningResult.ImageURL" class="brandLogo" />
                </div>
                <div class="tune-top-header-title">
                  {{ curTuningResult.Make }} {{ curTuningResult.ModelDescription }}
                </div>
              </div>

              <!-- discounts header/bar -->
              <div class="tune-top-header">
                <div  v-for="discount in discountsList" v-bind:key="discount.name">
                  <div v-if="(new Date(discount.sdate).getTime() < new Date().getTime() && new Date(discount.edate).getTime() > new Date().getTime()) && orderSystem == '1'">

                    <div class="discount-message-red">
                    {{ discount.description[$i18n.locale] }} 
                    </div>
                  </div>
                </div>


              </div>
              
          

            <div class="tuning-results-midpane" >
              <div class="tuning-results-products">
                <div
                  v-if="curTuningProducts.length > 0"
                  class="tuning-product-container"
                >
                  <div class="tuning-product-title-row hideMobile">
                    <div class="product-list-col1">&nbsp;</div>
                    <div class="product-list-col2 tuning-product-header">
                      {{ $t("standard") }}
                    </div>
                    <div class="product-list-col3 tuning-product-header">
                      {{ $t("tuned") }}
                    </div>
                    <div
                      class="product-list-col4 tuning-product-header hideMobile"
                    >
                      {{ $t("difference") }}
                    </div>
                    <div class="product-list-col5 tuning-product-header">
                      {{ $t("price") }}
                    </div>
                    <div
                      class="product-list-col6 tuning-product-header hideMobile"
                      v-if="selectedProduct.Price && orderSystem == '1' && hasSoftLoader"
                    >
                      {{ $t("add_to_cart") }}
                    </div>
                  </div>

                  <div
                    :class="product.ProductID == selectedProductID ?  'tuning-product-row product-row-selected' : 'tuning-product-row'"
                    v-for="product in curTuningProducts"
                    v-bind:key="product.ProductID"
                  >
                    <div
                      class="product-list-col1"
                      @click="showProductDetails(product.ProductID)"
                    >
                      <div>
                        <span style="float:left;">{{product.Category}}</span>

                        <span v-if="product.ProductCode == '50p'" style="float:left;">
                          <tippy boundary="dicon" :content="$t('50p_addon_discount_tooltip')" placement="right" >
                          <img id="dicon" class="discount-icon" :src="discount50percent" >
                          </tippy>
                        </span>
                      </div>
                    </div>
                    <div
                      class="product-list-col2 uppercase hideMobile"
                      @click="showProductDetails(product.ProductID)"
                    >
                      <div v-if="parseFloat(product.MaxModPower) > 0">
                        {{parseFloat(product.MaxBasePower)}} {{ $t("hp") }} /
                        {{ product.MaxBaseTorque }} {{ $t("nm") }}
                      </div>
                    </div>
                    <div
                      class="product-list-col3 uppercase hideMobile"
                      @click="showProductDetails(product.ProductID)"
                    >
                      <div v-if="parseFloat(product.MaxModPower) > 0">
                        {{parseFloat(product.MaxModPower)}} {{ $t("hp") }} /
                        {{ product.MaxModTorque }} {{ $t("nm") }}
                      </div>
                    </div>
                    <div
                      class="product-list-col4 uppercase "
                      @click="showProductDetails(product.ProductID)"
                    >
                      <div v-if="parseFloat(product.MaxModPower) > 0">
                        +{{ (product.MaxModPower-product.MaxBasePower)}}
                        {{ $t("hp") }} / +{{(product.MaxModTorque-product.MaxBaseTorque) }}
                        {{ $t("nm") }}
                      </div>
                    </div>
                    <div
                      class="product-list-col5 hideMobile"
                      @click="showProductDetails(product.ProductID)"
                    >
                  
                      <!-- <div v-if="product.DiscountDescription && product.ProductCode != '50p'"> -->
                      <div v-if="product.DiscountDescription && product.ProductCode !='50p'">
                          <div style="float:left;width:100%;text-decoration:line-through;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price))}}</div>
                          <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(extractDiscount(product.DiscountDescription))) }}</div>
                      </div>
                      <div v-else-if="product.ProductCode =='50p' ">
                        <div style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price))}}</div>
                        <!-- <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)/2)}} </div> -->
                      </div>
                      <div v-else>
                        <div style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(product.Price)) }}</div>
                      </div>
                      
                    </div>
                    <div class="product-list-col6 hideMobile">
                      <span
                        class="shop-row-icon"
                        @click="orderProduct(product)"
                        v-if="selectedProduct.Price && orderSystem == '1' && hasSoftLoader"
                      >
                        <img
                          :src="product.ProductID == selectedProductID ?  cartWhite : cartBlue"
                          class="button-icon"
                          alt="shop"
                        />
                        <!-- <i class="fa fa-2x fa-shopping-cart"></i> -->
                        <span class="count-orange">+</span>
                      </span>
                    </div>
                  </div>

                  <div class="tuning-results-line "><hr /></div>


                  <!-- Performance table desktop -->
                  <div class="tuning-results-top-frame ">
                    <div class="tuning-results-details-l">
          
                      <!-- Performance table -->
                      <div class="perf-table">
                        <div class="perf-table-header">
                          {{ selectedProduct.Category }}
                          <span v-if="selectedProduct.MaxModPower > 0">
                            : &nbsp;&nbsp;&nbsp;&nbsp;+{{ (selectedProduct.MaxModPower-selectedProduct.MaxBasePower)}}
                            {{ $t("hp") }}
                            <span class="yellow-text">/</span>
                            +{{(selectedProduct.MaxModTorque-selectedProduct.MaxBaseTorque) }}
                            {{ $t("nm") }}
                          </span>
                        </div>

                        <div
                          class="perf-table-title-row"
                          v-if="parseFloat(selectedProduct.MaxModPower) > 0"
                        >
                          <div class="perf-table-col">&nbsp;</div>
                          <div class="perf-table-col calign">
                            {{ $t("standard") }}
                          </div>
                          <div class="perf-table-col calign">{{ $t("tuned") }}</div>
                          <div class="perf-table-col calign">
                            {{ $t("difference") }}
                          </div>
                        </div>

                        <div
                          class="perf-table-row greybg2"
                          v-if="parseFloat(selectedProduct.MaxModPower) > 0"
                        >
                          <div class="perf-table-col bold">
                            &nbsp;{{ $t("power") }}
                          </div>
                          <div class="perf-table-col calign uppercase">
                            {{parseFloat(selectedProduct.MaxBasePower)}}
                            {{ $t("hp") }}
                          </div>
                          <div class="perf-table-col calign uppercase">
                            {{parseFloat(selectedProduct.MaxModPower)}} {{ $t("hp") }}
                          </div>
                          <div class="perf-table-col calign uppercase bold" style="background:#dddddd;">
                            +{{ (selectedProduct.MaxModPower-selectedProduct.MaxBasePower)}}
                            {{ $t("hp") }}
                          </div>
                        </div>

                        <div
                          class="perf-table-row greybg1"
                          v-if="parseFloat(selectedProduct.MaxModPower) > 0"
                        >
                          <div class="perf-table-col bold">
                            &nbsp;{{ $t("torque") }}
                          </div>
                          <div class="perf-table-col calign uppercase">
                            {{ selectedProduct.MaxBaseTorque }} {{ $t("nm") }}
                          </div>
                          <div class="perf-table-col calign uppercase">
                            {{ selectedProduct.MaxModTorque }} {{ $t("nm") }}
                          </div>
                          <div class="perf-table-col calign uppercase bold"  style="background:#f0f0f0;">
                            +{{(selectedProduct.MaxModTorque-selectedProduct.MaxBaseTorque) }}
                            {{ $t("nm") }}
                          </div>
                        </div>
                      </div>
                
                      <div class="tune-product-description hideMobile">
                          <p v-html="selectedProduct.Information"></p>
                        </div>
                        
                    </div>
                    <!-- End Performance table desktop -->

                    <div class="tuning-results-details-r">
                      <div class="tuning-results-vspacer hideMobile"></div>

                      <div class="dynoImageContainer">
                        <div v-if="selectedProduct.DynoChartImageURL != ''">
                        <img
                          :src="selectedProduct.DynoChartImageURL"
                          class="brandLogoContainer"
                        />
                        </div>
                        <div v-else>
                        <img
                          :src="selectedProduct.ProductImageURL"
                          class="brandLogoContainer"
                        />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="hideMobile">&nbsp;</div>




                  <!-- Product details -->
                  <div class="">
        

                    <div style="float: left; width: 100%">
      
                     
                        <div class="tune-product-description hideDesktop">
                          <p v-html="selectedProduct.Information"></p>
                        </div>

                        
                          <!-- {{selectedProduct.Price}} -->

                    
                        <div class="tuning-product-price" style="float:left;width:100%;height:100%;">


                          <!-- <div v-if="selectedProduct.DiscountDescription && selectedProduct.ProductCode != '50p'"> -->
                          <div v-if="selectedProduct.DiscountDescription">

                            <div style="float:left;width:100%;text-decoration:line-through;">&euro; {{ formatPrice(custom_fixUglyPrice(selectedProduct.Price))}}</div>
                            <div class="discount_price_red" style="float:left;width:100%;height:40px;">&euro; {{ formatPrice(custom_fixUglyPrice(extractDiscount(selectedProduct.DiscountDescription))) }} </div>
                           <!-- <div style="float:left;width:100%;">&nbsp;</div> -->
                          </div>
                          <div v-else-if="selectedProduct.ProductCode =='50p' ">
                          <div style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(selectedProduct.Price))}}</div>
                          <!-- <div class="discount_price_red" style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(selectedProduct.Price)/2)}} </div> -->
                          </div>                          
                          <div v-else>
                            <div style="float:left;width:100%;">&euro; {{ formatPrice(custom_fixUglyPrice(selectedProduct.Price)) }}</div>
                          </div>

                      
                        </div>


                        <div class="tune-action-block">
                          <div
                            class="tune-action-button-wrapper"
                            v-if="selectedProduct.Price && orderSystem == '1' && hasSoftLoader"
                          >
                            <div
                              class="tune-action-button"
                              @click="orderProduct(selectedProduct)"
                            >
                              + {{ $t("add_to_cart") }}
                            </div>
                          </div>
                          <div class="tune-action-button-wrapper" v-if="mailFunctions == 1">
                            <div 
                              class="tune-action-button"
                              @click="this.$router.push('/appointment')"
                            >
                              {{ $t("appointment") }}
                            </div>
                          </div>
                          <div class="tune-action-button-wrapper" v-if="mailFunctions == 1">
                            <div 
                              class="tune-action-button"
                               @click="this.$router.push('/request')"
                            >
                              {{ $t("request_info") }}
                            </div>
                          </div>
                          <div class="tune-action-button-wrapper">
                            <div
                              class="tune-action-button"
                              @click="downloadPDF()"
                            >
                              {{ $t("download_pdf") }}
                            </div>
                          </div>
                          <div class="tune-action-button-wrapper">
                            <div
                              class="tune-action-button"
                              @click="openDeeplink()"
                            >
                              {{ $t("share_link") }}
                            </div>
                          </div>
                        </div>
                      
                    </div>
                  </div>

                  <div class="tuning-results-endline">&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- <button id="show-modal" @click="renderModal('hallo')">Show Modal</button> -->
    <!-- use the modal component -->
    <transition name="modal">
      <modal v-if="showModal" @close="showModal = false" bottom>
        <!--
        you can use custom content here to overwrite
        default content
      -->
        <template v-slot:header> </template>
        <template v-slot:body>
          <span v-html="curModalBody"></span>
        </template>

        <template v-slot:footer>
          <div v-if="showModalFooter">
            <button
              class="modal-default-button"
              @click="showModal = false; hideProductAction()"
            >
              {{ $t("ok")}}
            </button>
          </div>
          <div v-else>&nbsp;</div>
        </template>
      </modal>
    </transition>
  </div>
</template>

<script>

import axios from 'axios'
import { Tippy } from 'vue-tippy'
import 'tippy.js/dist/tippy.css'





const methods= {
      scrollToTop() {
        window.scrollTo(0,0);
        if(window.parentIFrame) {
            window.parentIFrame.scrollTo(0,0);
        }
    },
  scrollParentToTop() {
    parentIFrame.scrollTo(0,0);
  },
    stripHTML(value) {
        const div = document.createElement('div')
        div.innerHTML = value
        const text = div.textContent || div.innerText || ''
        return text
    },
    changeItem: function changeItem(rowId, event) {

        this.productDetails = false;
        if(rowId == "make") {
            this.curVariants = [];
            this.selectedVariant = "";
            this.curTuningResult = "";
            this.curTuningProducts = [];
            this.hideProductDetails();
            this.selectedMake = null;
            this.curModels = [];
            this.selectedModel = "";
            // this.$store.commit("setCurVariants", this.curVariants);
            if( this.selectedMake != event.target.value && event.target.value != "") {
                this.hasResults = false;
                this.$store.commit("setCurSelectedProduct", "");
                this.selectedMake = event.target.value;
                this.getModels(this.selectedMake)
            }
        }
        if(rowId == "model") {
            this.getModels(this.selectedMake)
            this.selectedModel = event.target.value;
            this.getVariants(this.selectedModel)
        }
        if(rowId == "options") {
            this.selectedProductID = "";
            this.getModels(this.selectedMake)
            this.getVariants(this.selectedModel)
            this.selectedVariant = event.target.value;
            this.getTuningOptions() ;
        }
        if(rowId == "language") {
            var newLocale = event.target.value;
            this.$i18n.locale = newLocale;
            this.locale = newLocale
            window.curStrings = this.$i18n.messages[newLocale];
            this.$store.commit("setCurLanguage", newLocale);
            this.getTuningOptions()
        }
    },
    getMakes() {
        var par = this;
        // this.hasResults = false;
        var makesURL = this.urlParams+"&mode=MAKES";
        axios.get(makesURL + this.locale_string)
        .then(function(response) {
            par.curMakes = response.data.result.DB_VehicleMakes;
            par.$store.commit("setCurMakes", par.curMakes);
        })
        .catch(function (error) {
            console.log(error);
        })
    },
    getModels(make) {
        var par = this;
        // this.hasResults = false;
        this.$store.commit("setCurSelectedMake", make);
        this.$store.commit("setCurVariants", []);
        var modelsURL = this.urlParams+"&mode=MODELS&MakeID=";
        axios.get(modelsURL + make + this.locale_string)
        .then(function(response) {
            par.curModels = response.data.result.DB_Models;
            par.$store.commit("setCurModels", par.curModels);
        })
        .catch(function (error) {
            console.log(error);
        })
    },
    getVariants(model) {
        var par = this;
        this.curVariants = [];
        this.selectedVariant = "";
        this.selectedVariant = "";
        this.curSelectedProduct = [];
        this.curSelectedProductID = "";
        this.curTuningProducts = [];
        this.hideProductDetails();
        this.hasResults = false;
        this.$store.commit("setCurVariants", this.curVariants);
        // this.$store.commit("setCurModel", model);
        this.$store.commit("setCurSelectedModel", model);
        var variantsURL = this.urlParams+"&mode=VARIANTS&MakeID=";
        axios.get(variantsURL + this.selectedMake + "&ModelID=" + model + this.locale_string)
        .then(function(response) {
            if(response.data.result != "") {
                if(response.data.result.DB_Variants.length > 0) {
                  par.curVariants = response.data.result.DB_Variants;
                } else {
                  par.curVariants.push(response.data.result.DB_Variants);
                }
                par.$store.commit("setCurVariants", par.curVariants);
            } else {
                par.curTuningResult = "No variants found for this model";
            }
        })
        .catch(function (error) {
            console.log(error);
        })
    },
    getTuningOptions() {
        this.$store.commit("setCurSelectedVariant", this.selectedVariant);
        var par = this;
        par.hasResults = false;
        var tuningOptionsURL = this.urlParams+"&mode=VEHICLE&VehicleID=";
        axios.get(tuningOptionsURL +  this.selectedVariant + this.locale_string)
        .then(function(response) {
            par.curTuningResult = response.data.result;
            par.$store.commit("setCurTuningResult", par.curTuningResult);
            par.curTuningProducts = [];
            if(response.data.products.DB_ProductInfo.length > 0) {
                par.curTuningProducts = response.data.products.DB_ProductInfo;
            } else {
                par.curTuningProducts.push(response.data.products.DB_ProductInfo);
            }
            par.$store.commit("setCurTuningProducts", par.curTuningProducts);
            par.hasResults = true;
            for(var i=0 ; i < par.curTuningProducts.length ; i++) {
                var curPID = par.curTuningProducts[i];
                if(curPID["ProductID"] == par.selectedProductID || par.selectedProductID == undefined) {
                  par.selectedProduct = par.curTuningProducts[i];
                  par.selectedProductID = par.curTuningProducts[i]["ProductID"];
                }
            }
            if(par.selectedProductID == "") {
                par.selectedProduct = par.curTuningProducts[0];
                par.selectedProductID = par.curTuningProducts[0]["ProductID"];
            }
            par.$store.commit("setCurSelectedProduct", par.selectedProduct);
            par.$store.commit("setCurSelectedProductID", par.selectedProductID);
            par.showProductDetails(par.selectedProductID)

        })
        .catch(function (error) {
            console.log(error);
            par.hasResults = false;
        })
    },
    showProductDetails(pid) {
        // this.$store.commit("setCurSelectedProduct", pid);
     var par = this;
        for(var i=0 ; i < this.curTuningProducts.length ; i++) {
            var curPID = this.curTuningProducts[i]["ProductID"];
            if(curPID == pid) {
              this.selectedProduct = this.curTuningProducts[i];
            }
            this.selectedProductID = pid;
        }
        this.$store.commit("setCurSelectedProduct", this.selectedProduct);
        this.$store.commit("setCurSelectedProductID", pid);
        this.productDetails = true;
    },
    hideProductDetails() {
        this.actionDialog = false;
    },
    productAction(mode, pid) {
        window.scrollTo(0, 0);
        this.actionDialog = true;
        this.productDetails = false;
        this.curActionMode = mode;

    },
    hideProductAction() {
        this.actionDialog = false;
        this.productDetails = true;
    },
    downloadPDF() {
        window.open(this.apiHost + "?ep=pdfgen&vehicle="+ this.$store.state.curSelectedVariant + "&cc=" + this.$i18n.locale)
    },
    openDeeplink() {
        var host = window.location.protocol + "//" + window.location.host;
        var dl = host + "/?make=" + this.selectedMake + "&model=" + this.selectedModel + "&variant=" + this.selectedVariant + "&product=" + this.selectedProductID;
        var linkIcon = this.buttonLinkIcon;
        this.showModal = true
        this.showModalFooter = false;
        this.curModalBody = '<div class="modal-deeplink-text">';
        this.curModalBody += '<div class="share-link-left">';
        this.curModalBody += '<input type="text" id="deeplink-src" value="'+dl+'" class="copy-link-textfield" autofocus onfocus="this.select()" style="width:100%;">';
        this.curModalBody += '</div>';
        this.curModalBody += '<div class="share-link-right">';
        this.curModalBody += '<div class="tune-action-button" onmousedown="copyLink(\''+dl+'\','+this.data+');$emit(\'close\');" >';
        this.curModalBody += '<div style="float:left;width:60px;"><img src="'+linkIcon+'" class="copy-link-icon"></div>';
        this.curModalBody += '<div style="float:left;">' + window.curStrings["copy_link"] + '</div>';
        this.curModalBody += '</div>'
        this.curModalBody += '</div>';
        this.curModalBody += '</div>';
        this.curModalFooter = '';
        // this.scrollToTop();
    },

    renderModal(msg) {
        this.showModal = true;
        this.curModalBody = msg;
    },

    orderProduct(pid) {
        this.selectedProduct = pid;
        this.selectedProduct.Information = ""; // often gets invalid json from WepAPI 
        this.selectedProduct.ProductDetails = ""; // often gets invalid json from WepAPI
        this.selectedProduct.ProductDescription = ""; // often gets invalid json from WepAPI
        this.$store.commit("addProduct", this.selectedProduct);
        this.selectedProduct = pid;
            // this.renderModal(window.curStrings["inforequest_sent"]); return false;
        this.curModalBody = '<div class="modal-deeplink-text">' + window.curStrings["product_added"] +  '</div><br><div class="modal-deeplink-text2">' + window.curStrings["product_added_reminder"] + '</div>';
        this.showModalFooter = true;
        this.showModal = true;
        // wait 2 seconds, then close the modal
        // setTimeout(() => {
        //     this.showModal = false;
        // }, 2000)
    },
    gotoShop() {
        this.$router.push("shop")
    },
    getParentUrl() {
      var isInIframe = (parent !== window),
      parentUrl = window.location;

      if (isInIframe) {
      parentUrl = document.referrer;
      }

      return parentUrl;
    },

      getHostDomain() {
      var hostname = new URL(window.location).hostname;

      return hostname;
    },

    getHostName(url) {
    // use URL constructor and return hostname
      var theURL = "";
      if(url != "") {
        theURL = new URL(url).hostname;
      }
      return theURL;
    }


}

export default {
    props: ['id'],
    data() {
      var curLocale =  this.$store.state.curLanguage;
      window.curStrings = this.$i18n.messages[curLocale];
      var apiHost =  process.env.VUE_APP_RICA_API_HOST;
      var curMakes = this.$store.state.curMakes;
      var curModels = this.$store.state.curModels;
      var curVariants = this.$store.state.curVariants;
      var curTuningProducts = this.$store.state.curTuningProducts;
      var selectedMake = this.$store.state.curSelectedMake;
      var selectedModel = this.$store.state.curSelectedModel;
      var selectedVariant = this.$store.state.curSelectedVariant;
      var selectedProduct = this.$store.state.curSelectedProduct;
      var selectedProductID = this.$store.state.curSelectedProductID;
      var curTuningResult = this.$store.state.curTuningResult;
      // var discountsList = this.$store.state.discountList;
      var hasResults = false;
      var productDetails = false;
      var showModal = false;
      var curModalHeader = "cur header";
      var curModalBody = "cur body";
      var curModalFooter = "cur footer";
      var showModalFooter = false;
      if(selectedProduct > 0) {
        hasResults = true;
        productDetails = true;
      }

      return {
        locale: curLocale,
        endpoint: "GetVehicles",
        apiHost: apiHost,
        urlParams: apiHost + "?&ep=GetVehicles",
        img1:require('./../assets/header-logo.png'),
        img2:require('./../assets/bgimage.jpg'),
        img3:require('./../assets/logo.png'),
        discount50percent:require('./../assets/discount50percent.png'),
        cartBlue:require('./../assets/shoppingcart-blue.png'),
        cartWhite:require('./../assets/shoppingcart-white.png'),
        buttonOrderIcon:require('./../assets/button-cart-grey.png'),
        buttonAppointmentIcon:require('./../assets/button-appointment.png'),
        buttonContactIcon:require('./../assets/button-contact.png'),
        buttonInfoIcon:require('./../assets/info-grey.png'),
        buttonDownloadIcon:require('./../assets/button-pdf.png'),
        buttonLinkIcon:require('./../assets/copy-white.png'),
        actionDialog:false,
        curActionMode:null,
        selectedMake:selectedMake,
        selectedModel:selectedModel,
        selectedVariant:selectedVariant,
        selectedProduct: selectedProduct,
        selectedProductID: selectedProductID,
        hasResults: hasResults,
        productDetails: productDetails,
        curMakes: curMakes,
        curModels: curModels,
        curVariants:curVariants,
        curTuningResult:curTuningResult,
        curTuningProducts:curTuningProducts,
        showModal:showModal,
        curModalHeader:curModalHeader,
        curModalBody:curModalBody,
        curModalFooter:curModalFooter,
        showModalFooter:showModalFooter
        // discountsList: discountsList
      }
    },
    computed: {
      // siteLinkout: function() {
      //   return "https://rica.nl";
      // },
        locale_string: function () {
          // return "&lc="+this.$i18n.locale+"&cc="+this.$i18n.locale
          return "&lc="+this.$i18n.locale+"&cc=nl" // only retrieve NL euro prices (2023)
        },
        itemsInCart: function () {
          return this.$store.state.shoppingCart.length;
        },
        orderSystem: function () {
          return this.$store.state.orderSystem;
        },
        mailFunctions: function () {
          return this.$store.state.mailFunctions;
        },
        hasDiscounts: function () {
          return this.$store.state.hasDiscounts;
        },
        curPowerVal: function () {
          var p = this.$store.state.curSelectedProduct;
          var v = p.MaxModPower-p.MaxBasePower;
          return v;
        },
        curTorqueVal: function () {
          var p = this.$store.state.curSelectedProduct;
          var v = p.MaxModTorque-p.MaxBaseTorque;
          return v;
        },
    },
    methods: methods,
    mounted() {
      // get language & currency settings
      this.$i18n.locale =  this.$store.state.curLanguage
      fetch('https://api.ipify.org?format=json')
      .then(x => x.json())
      .then(({ ip }) => {
          this.$store.commit("setClientIP", ip);
      });


      var par = this;

      // determine state by host domain
      var parentURL = this.getParentUrl();
      var hostname = this.getHostDomain();


      if(hostname == "hq.rica.nl"  || hostname == "192.168.1.13") {
        this.$store.commit("setOrderSystem", "1");
           this.$store.commit("setMailFunctions", "1");
      } else if(hostname == "dealer.rica.nl") {
        this.$store.commit("setOrderSystem", "0");
           this.$store.commit("setMailFunctions", "1");
      } else {
        this.$store.commit("setOrderSystem", "0");
           this.$store.commit("setMailFunctions", "0");
      }

      // get discounts list
      var discountsURL = this.$store.state.cdn_url+"/tooldata/discounts.json";
      axios.get(discountsURL)
      .then(function(response) {
        var dl = JSON.parse(JSON.stringify(response.data));
        par.$store.commit("setDiscountList", dl);
      })
      .catch(function (error) {
        console.log(error);
      })

         // get tool state list
      var toolstatesURL = this.$store.state.cdn_url+"/tooldata/toolstates.json";
      axios.get(toolstatesURL)
      .then(function(response) {
        var dl = JSON.parse(JSON.stringify(response.data));
        if(response.data[hostname]) {
          par.$store.commit("setMailFunctions", response.data[hostname]["contact"]);
          par.$store.commit("setOrderSystem", response.data[hostname]["shop"]);          
          par.$store.commit("setLogoLinkout", response.data[hostname]["website"]);          
          par.$store.commit("setHostDomain", hostname);          

          
        } else {
          console.log("Toolstates: no config found");
          
        }
        // par.$store.commit("setDiscountList", dl);
      })
      .catch(function (error) {
        console.log(error);
      })



        if(this.$route.query.profile) {
          if (this.$route.query.profile != "") {
            let file = document.createElement('link');
            file.rel = 'stylesheet';
            file.href = this.$store.state.cdn_url+"/tooldata/css/"+this.$route.query.profile+".css";
            document.head.appendChild(file)
          }
        }
        if(this.$route.query.lang) {
          this.$i18n.locale = this.$route.query.lang;
          this.$store.commit("setCurLanguage", this.$route.query.lang);
           window.curStrings = this.$i18n.messages[this.$i18n.locale];
        }
        if(this.$route.query.make) {
            this.selectedMake = this.$route.query.make;
            this.getModels(this.selectedMake)
        }
        if(this.$route.query.model) {
          this.selectedModel = this.$route.query.model;
          this.getVariants(this.selectedModel)
        }
        if(this.$route.query.variant) {
          this.selectedVariant = this.$route.query.variant;
          this.getTuningOptions()
        }
        // phased out, is now determined by (parent) domain
        // if(this.$route.query.orders) {
        //   console.log("this.$route.query.orders: " + this.$route.query.orders);
        //   if(this.$route.query.orders == "1") {
        //     this.$store.commit("setOrderSystem", "1");
        //   } else {
        //     this.$store.commit("setOrderSystem", "0");
        //   }
        // }
        if(this.$route.query.product) {
            this.hasResults = true;
            this.selectedProductID = this.$route.query.product;
            this.$store.commit("setCurSelectedProductID", this.$route.query.product);
        }
        if(this.$route.query.reset) {
          this.$store.commit("reset");
          this.curSelectedMake = "";
          this.selectedVariant = "";
          this.curSelectedProduct = "";
          this.curSelectedProductID = "";
          this.getMakes()             
        }
        if( this.selectedProduct.ProductID != undefined) {
          this.hasResults = true;
          this.showProductDetails(this.selectedProduct.ProductID)
        } else {
            this.getMakes()
            if(this.selectedVariant != "") {
              this.curTuningProducts = [];
              this.getTuningOptions();
            }
        }

    },
  components: {
    'cart-view': require('@/views/ShoppingCartView.vue').default,
    'appointment-view': require('@/views/AppointmentView.vue').default,
    'inforequest-view': require('@/views/InfoRequestView.vue').default,
    'perf-circle': require('@/components/PerformanceCircle.vue').default,
    'bottom-bar': require('@/components/BottomBar.vue').default,
    'logo-link': require('@/components/LogoLink.vue').default,
     Tippy
  }
}

function wait(ms){
  var start = new Date().getTime();
  var end = start;
  while(end < start + ms) {
    end = new Date().getTime();
  }
}

window.copyLink = function (link, ob) {
  copyTextToClipboard(link);
  ob = false;
}

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
  } catch (err) {
    console.error('Fallback: unable to copy', err);
  }
  document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });
}
</script>
